// extracted by mini-css-extract-plugin
export default {"fileWrapper":"MessageFile__fileWrapper--6H17g","fileIcon":"MessageFile__fileIcon--whNy4","fileName":"MessageFile__fileName--sa4ow"};